<template lang="pug">
  .component-client-action-buttons(v-if="entity")
    ul.dropdown.menu(v-if="item", data-dropdown-menu='', v-f="")
      li
        a(href='#Item-1') Action
        ul.menu
          li
            a(@click="edit") Edit
          li
            a(v-on:click="enable" v-if="entity.slot_disabled === 1 && entity.archived_at === ''") Enable Vehicle Slot
          li
            VehicleSlotDisableReveal(:item="entity", v-if="entity.slot_disabled === 0")          li
          li
            a(v-on:click="archive" v-if="!entity.archived_at") Archive
          li
            a(v-on:click="requestData") Request data
          li
            a(@click="openDoors") Open Doors
          li
            a(@click="closeDoors") Close Doors
    .dropdown-buttons(v-else)
      a.success-text(v-on:click="enable" v-if="entity.slot_disabled === 1") Enable
      VehicleSlotDisableReveal(:item="entity", v-if="entity.slot_disabled === 0")
      swap-asset(:item="vehicleSlot", v-if="entity.slot_id", @processSwap="processSwap")
      move-asset(:item="vehicleSlot", v-if="entity.slot_id")
      ToggleHiddenOnMap(:vehicle="entity")
      a.warning-text(v-on:click="dismiss", v-if="entity.slot_id") Dismiss
      router-link.alert-text(:to="{name:'operations', params:{id:entity.id}}", v-if="entity.slot_id") Drain
      ForceRebook(:vehicle="entity" )

</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from 'src/maggieHelper'
import VehicleSmartEdit from 'components/backoffice/smartedits/VehicleEdit'
import AssetManagementActionButtons from './AssetManagementActionButtons'
import SwapAsset from './asset-management/SwapAsset'
import MoveAsset from './asset-management/MoveAsset'
import DismissAsset from './asset-management/DismissAsset'
import ModalReveal from '../../foundation/ModalReveal'
import SelectizeDriver from '../lists/selectize/SelectizeDriver'
import DatePicker from '../../DatePicker'
import ForceRebook from './reveal/ForceRebook'
import VehicleSlotDisableReveal from "./reveal/VehicleSlotDisableReveal";
import ToggleHiddenOnMap from "./reveal/ToggleHiddenOnMap.vue";

export default {
  name: 'VehicleSlotButtons',
  components: {
    ToggleHiddenOnMap,
    VehicleSlotDisableReveal,
    ForceRebook,
    DatePicker,
    SelectizeDriver,
    ModalReveal, DismissAsset, MoveAsset, SwapAsset, AssetManagementActionButtons, VehicleSmartEdit
  },
  data() {
    return {
      entity: null,
      start: null,
      end: null
    }
  },
  created() {
    if (!this.vehicle) {
      KeplerBackofficeSdk.vehicles.select(this.$route.params.id).get((item) => {
        this.entity = item
      })
    } else {
      this.entity = this.vehicle
    }

  },
  methods: {
    closeDoors() {

      this.$confirm('Are you sure?', 'Do you really want to close the doors?', () => {

        KeplerBackofficeSdk.vehicles.select(this.entity.id, null).closeDoors(() => {
          this.$emit('update')
          MaggieHelper.notification('Close Request', 'Door close signal has been sent')
        })
      })

    },
    openDoors() {
      this.$confirm('Are you sure?', 'Do you really want to open the doors?', () => {

        KeplerBackofficeSdk.vehicles.select(this.entity.id, null).openDoors(() => {
          this.$emit('update')
          MaggieHelper.notification('Close Request', 'Door open signal has been sent')
        })
      })
    },
    edit() {
      MaggieHelper.openRightPanel({
        component: VehicleSmartEdit, props: {
          item: this.entity
        }
      })
    },
    requestData() {
      KeplerBackofficeSdk.vehicles.select(this.entity.id, null).getData((response) => {
        MaggieHelper.notification('data-request-esit', response)
      })
    },
    enable: function () {
      KeplerBackofficeSdk.vehicleSlots.select(this.entity.slot_id).enable((response) => {
        MaggieHelper.notification('enable-esit', 'vehicle slot enabled')
      })
    },
    dismiss() {
      this.$confirm('Are you sure?', `Do you really want to dismiss the vehicle slot<br>${this.entity.slot_name} (VS-${this.entity.slot_id})?`, () => {
        KeplerBackofficeSdk.vehicleSlots.select(this.entity.slot_id).dismiss((data) => {
          this.$emit('vehicleSlotDismissed', this.vehicleSlot)
          MaggieHelper.notification('dismiss-esit', 'Vehicle slot dismissed')
        })
      })
    },
    archive() {
      this.$confirm('Are you sure?', 'Do you really want archive this vehicle?', () => {
        KeplerBackofficeSdk.vehicles.list().archive(this.entity.id, (data) => {
          MaggieHelper.notification('Archive Request', 'Vehicle archived')
        })

      })
    },
    assetMoved(item) {
      this.$emit('assetMoved', item)
    },
    processSwap(id) {
      this.$confirm('Are you sure?', `Do you really want to swap VS-${this.vehicleSlot.id} with VS-${id}?`, () => {

        KeplerBackofficeSdk.vehicleSlots.swap({
          first_vehicle_slot_id: this.vehicleSlot.id,
          second_vehicle_slot_id: id
        }, (data) => {
          MaggieHelper.notification('swap-esit', data.result)
        })
      })
    }
  },
  props: ['vehicle', 'item'],
  computed: {
    vehicleSlot() {
      return {id: this.entity.slot_id, name: this.entity.slot_name}
    }
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleSlotButtons.vue?c5c84d26